var $82c9b25b834471a2$exports = {};
$82c9b25b834471a2$exports = {
    "clear": `\u{30AF}\u{30EA}\u{30A2}`,
    "invalid": `(\u{7121}\u{52B9})`,
    "loading": `\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}...`,
    "noResults": `\u{7D50}\u{679C}\u{306A}\u{3057}`
};


export {$82c9b25b834471a2$exports as default};
//# sourceMappingURL=ja-JP.module.js.map
